import React from "react";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
	track: {
		display: "flex",
		width: "100%",
		height: 20,
		borderRadius: 10,
		overflow: "hidden",
		backgroundColor: theme.palette.mode === "light" ? "#e1e0d9" : "#2c2c2a",
	},
	segment: {
		height: "100%",
		transition: "flex-basis 0.3s ease",
		cursor: "pointer",
	},
	gap: {
		width: 2,
		height: "100%",
		backgroundColor: theme.palette.background.paper,
	},
	legend: {
		display: "flex",
		flexWrap: "wrap",
		gap: theme.spacing(2),
		marginTop: theme.spacing(1.5),
	},
	legendItem: {
		display: "flex",
		alignItems: "center",
		gap: 6,
		cursor: "pointer",
	},
	swatch: {
		width: 10,
		height: 10,
		borderRadius: 3,
		flexShrink: 0,
	},
	legendLabel: {
		fontSize: 13,
		color: theme.palette.text.secondary,
	},
	legendValue: {
		fontSize: 13,
		fontWeight: 600,
		color: theme.palette.text.primary,
	},
}));

const SegmentedBar = ({ items, onSegmentClick }) => {
	const { classes } = useStyles();
	const total = items.reduce((sum, item) => sum + (item.value || 0), 0);

	return (
		<Box>
			<Box className={classes.track}>
				{total === 0 ? (
					<Box className={classes.segment} style={{ flex: 1, backgroundColor: "transparent" }} />
				) : (
					items.map((item, index) => {
						if (!item.value) return null;
						return (
							<React.Fragment key={item.name}>
								{index > 0 && <div className={classes.gap} />}
								<div
									className={classes.segment}
									style={{ flexBasis: `${(item.value / total) * 100}%`, backgroundColor: item.color }}
									title={`${item.name}: ${item.value}`}
									onClick={() => onSegmentClick && onSegmentClick(item)}
								/>
							</React.Fragment>
						);
					})
				)}
			</Box>
			<Box className={classes.legend}>
				{items.map((item) => (
					<Box
						key={item.name}
						className={classes.legendItem}
						onClick={() => onSegmentClick && onSegmentClick(item)}
					>
						<span className={classes.swatch} style={{ backgroundColor: item.color }} />
						<Typography className={classes.legendLabel}>{item.name}</Typography>
						<Typography className={classes.legendValue}>{item.value}</Typography>
					</Box>
				))}
			</Box>
		</Box>
	);
};

export default SegmentedBar;
